import React from 'react';

import { LogOut, Undo, User } from 'lucide-react'; // Importing Lucide React's LogOut icon
import { useNavigate } from 'react-router-dom';
import {
  ImpersonationDTO,
} from '../../services/apiClient';
import axiosInstance from '../../services/axiosInstance';
import { getAdminId, getPermissions, getRoles, clearAllTokens } from '../../utils/tokenUtils';
import { useAuthApi } from '../../hooks/useAuthApi';

const ProfileMenu: React.FC = () => {
  const navigate = useNavigate();
  const adminId = getAdminId();
  const userPermissions = getPermissions();
  const canViewProfile = !userPermissions?.includes('Main.MemberSetup.View');
  const roles = getRoles();
  const isAdmin = roles?.includes('Admin');

  const { impersonateMemberLogout } = useAuthApi();

  const handleLogout = (): void => {
    // Clear all tokens from both storages using centralized function
    clearAllTokens();

    // Navigate to login page
    navigate('/login');
  };

  const handleImpersonateLogout = async (): Promise<void> => {
    if (!adminId) {
      console.error('No admin ID found for impersonation logout');
      return;
    }

    try {
      // Backend extracts userId and adminId from JWT token claims
      // No need to send them in the request body
      await impersonateMemberLogout({} as ImpersonationDTO);
    } catch (error) {
      console.error('Error logging out of impersonation', error);
    }
  };

  const handleProfileView = (): void => {
    if (roles?.includes('Admin')) {
      navigate('/admin/profile');
    }
    else {
      navigate('/admin/member-profile');
    }
  }

  return (
    <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 border rounded-lg shadow-lg py-2 z-[100]">
      {(isAdmin || canViewProfile) && (
        <button
        className="flex items-center gap-2 px-4 py-2 w-full text-left text-gray-700 hover:bg-gray-100 focus:outline-none cursor-pointer"
        onClick={handleProfileView}
        aria-label="Log out"
      >
        <User className="w-5 h-5 text-gray-500" />
        <span>My Profile</span>
      </button>
      )}
      {!adminId && (
        <button
          className="flex items-center gap-2 px-4 py-2 w-full text-left text-gray-700 hover:bg-gray-100 focus:outline-none cursor-pointer"
          onClick={handleLogout}
          aria-label="Log out"
        >
          <LogOut className="w-5 h-5 text-gray-500" />
          <span>Log Out</span>
        </button>
      )}
    </div>
  );
};

export default ProfileMenu;
